module.exports = __webpack_public_path__ + "static/media/GoodyPack_cat_1200x628.8ff7c955.jpg";